import { Box } from "native-base";
import { InterfaceBoxProps } from "native-base/lib/typescript/components/primitives/Box";
import { InterfaceImageProps } from "native-base/lib/typescript/components/primitives/Image/types";
import React from "react";

import { useViewport } from "@/contexts/ViewportContext";

import ExternalImage from "../ExternalImage";

type ComponentProps = {
  logoUrl: string;
  inactive?: boolean;
  size?: InterfaceBoxProps["size"];
  imageSize?: InterfaceImageProps["size"];
};

const RoundedLogo = ({ logoUrl, size, inactive = false }: ComponentProps) => {
  const { isWebMode } = useViewport();
  return (
    <Box
      size={size ? size : isWebMode ? "24" : "20"}
      rounded="full"
      bgColor="white.50"
      shadow="4"
      justifyContent="center"
      alignItems="center">
      <ExternalImage
        source={{ uri: logoUrl }}
        width="100%"
        height="100%"
        borderRadius={100}
        contentFit="contain"
        opacity={inactive ? 0.5 : 1}
      />
    </Box>
  );
};

export default RoundedLogo;
